<template>
    <div v-if="!loadingPage">
        <b-card-text>
            <div class="mt-2 px-2">
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent>
                        <div class="row">
                            <div class="col-md-6 mb-25">
                                <b-form-group label="نام" label-for="nameId">
                                    <validation-provider #default="{ errors }" name="نام" rules="required">
                                        <b-form-input v-model="form.Name_Fa"
                                            :state="errors.length > 0 ? false : null"></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 mb-25">
                                <b-form-group label="نام انگلیسی" label-for="nameEnId">
                                    <b-form-input v-model="form.Name_En"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-12 mb-25">
                                <b-form-group label="توضیحات" label-for="descriptionId">
                                    <b-form-textarea rows="3" no-resize dir="rtl" class="text-primary-middle"
                                        v-model="form.description"></b-form-textarea>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-md-between align-items-center flex-md-row flex-column mt-1">
                            <div class="d-flex align-items-center">
                                <b-form-radio class="mr-2" v-model="selected" name="selection-mode" value="default">
                                    انتخاب آیکون
                                </b-form-radio>
                                <b-form-radio v-model="selected" name="selection-mode" value="upload">
                                    بارگذاری آیکون
                                </b-form-radio>
                            </div>
                            <b-button type="submit" variant="primary" @click="editCategories"
                                :disabled="invalid || loading" class="px-5 mt-3 mt-md-0 d-flex align-items-center">
                                <span>ویرایش</span>
                                <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                            </b-button>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div v-if="selected == 'upload'" class="mb-md-4 mt-md-3 my-3"
                                style="width: 250px;height: 250px;">
                                <div v-if="!data.categoryIconImage" @click="selectFile"
                                    :class="{ 'upload-file': !imageBlob }"
                                    class="pointer d-flex justify-content-center align-items-center">
                                    <input @change.prevent="createFile" ref="fileInput" type="file" hidden />
                                    <div v-if="!imageBlob">
                                        <feather-icon size="95" icon="UploadCloudIcon" color="#7367f0f0" />
                                        <h5 class="text-primary mb-0">بارگذاری تصویر</h5>
                                    </div>
                                    <div v-if="imageBlob" class="categories-img">
                                        <b-img :src="imageBlob" class="object-fit-cover w-100 h-100"
                                            style="border-radius: 18px;" />
                                    </div>
                                </div>
                                <div v-if="data.categoryIconImage" class="position-relative">
                                    <div @click="removeIcon"
                                        class="position-absolute pointer bg-primary rounded-circle p-25"
                                        style="left: 4px;top: 4px;z-index: 2;">
                                        <feather-icon size="22" icon="XIcon" class="text-white" />
                                    </div>
                                    <div class="categories-img">
                                        <b-img :src="BASE_URL_File + data.categoryIconImage"
                                            class="object-fit-cover w-100 h-100" style="border-radius: 18px;" />
                                    </div>
                                    <div v-if="!data.newContentsAccepted"
                                        class="position-absolute d-flex justify-content-center align-items-center w-100 h-100 user-select-none"
                                        style="top: 0;background-color: rgba(0, 0, 0, 0.6);border-radius: 18px;">
                                        <div class="text-warning font-weight-bolder" style="font-size: 13px;">
                                            در حال بررسی
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selected == 'default'" class="row my-3">
                            <div v-for="(item, index) in categoryIcons" :key="index"
                                class="col-6 col-xl-1 col-lg-2 col-md-4 mb-2">
                                <div @click="selectIcon(item.id)" class="bg-icon pointer rounded"
                                    :class="{ 'bg-active-icon': item.id == form.DefaultCategoryIconId }">
                                    <div class="d-flex justify-content-center">
                                        <div class="w-100 h-100">
                                            <img :src="BASE_URL_File + item.icon" class="w-100 h-100 object-fit-cover">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
        </b-card-text>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormRadio, BForm, BFormInput, BFormFile, BSpinner, BTable, BAvatar, BImg, BFormGroup, BFormTextarea } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, min, max } from '@validations';
import { storeService } from '@core/services';
import Compressor from 'compressorjs';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BFormGroup,
        BSpinner,
        BTable,
        BAvatar,
        BFormTextarea,
        BFormRadio,
        BImg,
        ValidationProvider,
        ValidationObserver
    },
    props: {
        data: {
            type: Object,
            default: () => { },
        },
        index: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            loadingPage: true,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            selected: 'default',
            required,
            min,
            max,
            storeId: null,
            file: null,
            loading: false,
            imageBlob: null,
            form: {
                Name_Fa: null,
                Name_En: null,
                description: null,
                DefaultCategoryIconId: null,
                CategoryIconImage: null,
                RemoveCurrentIcon: false,
            },
            categoryIcons: [],
            parameters: {
                pageIndex: 1,
                pageSize: 90
            }
        }
    },
    watch: {
        selected() {
            this.form.CategoryIconImage = null
            this.form.DefaultCategoryIconId = null
            this.imageBlob = null
        }
    },
    methods: {
        createFile(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.CategoryIconImage = result
                            if (this.form.CategoryIconImage) {
                                this.imageBlob = URL.createObjectURL(this.form.CategoryIconImage);
                            }
                        },
                    });

                }
                else {
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        removeIcon() {
            this.data.categoryIconImage = null
        },
        getCategoryIconList() {
            this.loadingPage = true
            storeService.categoryIconList(this.storeId, this.parameters).then(({ data }) => {
                this.categoryIcons = data.items
                this.loadingPage = false
            })
        },
        selectIcon(id) {
            this.form.DefaultCategoryIconId = id
        },
        selectFile() {
            this.$refs['fileInput'].click();
        },
        editCategories() {
            this.loading = true;
            let formData = new FormData();
            if (!this.data.categoryIconImage && !this.form.CategoryIconImage) {
                this.form.RemoveCurrentIcon = true
                formData.append("RemoveCurrentIcon", this.form.RemoveCurrentIcon)
            }
            this.form.Name_Fa ? formData.append("Name_Fa", this.form.Name_Fa) : null
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.description ? formData.append("description", this.form.description) : null
            this.form.DefaultCategoryIconId ? formData.append("DefaultCategoryIconId", this.form.DefaultCategoryIconId) : null
            this.form.CategoryIconImage ? formData.append("NewCategoryIconImage", this.form.CategoryIconImage, this.form.CategoryIconImage.name) : null
            storeService.editCategories(this.storeId, formData, this.data.id).then(({ data }) => {
                this.$emit('editCategories', this.index);
                this.$notif({ type: 'success', title: 'دسته‌بندی با موفقیت ویرایش شد' });
            })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.data.name_Fa != 'null' ? this.form.Name_Fa = this.data.name_Fa : null
        this.data.name_En != 'null' ? this.form.Name_En = this.data.name_En : null
        this.data.description != 'null' ? this.form.description = this.data.description : null
        this.data.defaultCategoryIconId != 'null' ? this.form.DefaultCategoryIconId = this.data.defaultCategoryIconId : null
        this.storeId = localStorage.getItem("storeId")
        this.getCategoryIconList();
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.upload-file {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%235E50EE95' stroke-width='4' stroke-dasharray='8%2c 16' stroke-dashoffset='15' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 18px;
    Width: 100%;
    height: 250px;
    margin: 0 0 0 0;
}

.categories-img {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 16px;
    width: 250px;
    height: 250px;
}

.user-select-none {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.bg-active-icon {
    background-color: rgb(0, 0, 0) !important;
    box-shadow: #7367f0 0px 0px 13px;
    border: 2px solid #7367f0 !important;
}

.bg-icon {
    background-color: rgb(42, 43, 48);
    border: 2px solid transparent;
}
</style>